import type { ComparisonPage } from '../../seo/marketingContent.js';
import { MarketingPage } from './MarketingPage.js';

/**
 * A head-to-head page, for someone who arrived by searching a competitor's name.
 *
 * The competitor column states what that product's own pricing page says, and
 * the page shows when it was read and links the source. Anyone can check it,
 * which is the only way a page like this stays worth trusting as prices move.
 */
export function Comparison({ page }: { page: ComparisonPage }) {
  return (
    <MarketingPage
      eyebrow={`FloorPoll compared with ${page.competitor}`}
      heading={page.heading}
      lede={page.lede}
    >
      <section className="landing-act">
        <div className="landing-act-inner">
          <h2>Side by side</h2>
          <div className="marketing-table-wrap">
            <table className="marketing-table">
              <thead>
                <tr>
                  <th scope="col">
                    <span className="visually-hidden">What is being compared</span>
                  </th>
                  <th scope="col">FloorPoll</th>
                  <th scope="col">{page.competitor}</th>
                </tr>
              </thead>
              <tbody>
                {page.rows.map((row) => (
                  <tr key={row.dimension}>
                    <th scope="row">{row.dimension}</th>
                    <td>{row.floorpoll}</td>
                    <td>{row.competitor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="marketing-source">
            {page.competitor} details read in {page.checked} from{' '}
            {page.sources.map((source, index) => (
              <span key={source.url}>
                {index > 0 ? ' and ' : ''}
                {/* nofollow: no reason to vouch for a competitor's ranking
                    from a page written to outrank them. */}
                <a href={source.url} rel="nofollow noopener noreferrer" target="_blank">
                  {source.label}
                </a>
              </span>
            ))}
            . Plans change — check the current pages before deciding.
          </p>
        </div>
      </section>
    </MarketingPage>
  );
}
